import { graphql } from 'react-relay';

export const gqlScheduleDelistAll = graphql`
  mutation scheduleDelistAllMutation($listingId: String!) {
    invsysScheduleDelistAll(listingId: $listingId) {
      success
    }
  }
`;
